import { useLayoutEffect, useRef } from 'react';
export function useLatestHandlers(handlers) {
  var handlerRef = useRef(handlers);
  useLayoutEffect(function () {
    handlerRef.current = handlers;
  });
  return handlerRef;
}